import {
	PostRequestUploadFile,
	PostRequestUploadFileParams,
	PostRequestUploadFileResponse,
} from 'domain/usecases/others/facial-biometric/';

import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';

export class RemoteFacialBiometricPostUploadFile implements PostRequestUploadFile {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<PostRequestUploadFileResponse>,
	) {}

	async post(params: PostRequestUploadFileParams): Promise<PostRequestUploadFileResponse> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'post',
			body: params,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
